import React from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../constants/globalConstants'

function ParkingSchModal(props) {
    const { isModalOpen, setIsModalOpen, Message, data,  cancleButtonColor, cancelButton, SubmitButton, cancelButtonLabel, SubmitButtonLable, SubmitButtonColor, handleLogout, handleSubmit, isHandleSubmit, setIsSubmittingForm } = props
    
    const handleClose = () => {
        setIsModalOpen()
        setIsSubmittingForm()
    }

    const handleFormSubmit = () => {
        setIsSubmittingForm(true)
        handleSubmit()
    }
    return (
        <>
            <Modal show={isModalOpen} onHide={() => handleClose()} centered>
                <Modal.Body className='messageCss'>
                    <p className='text-primary'>Do you want to Continue this Parking?</p>
                    <p>{Message}</p>
                    {data?.map((item, index) =>
                        <Row key={index}>
                            <Col>{item?.day}</Col>
                            <Col xs={6}>{item?.formatted_coupon_detail_open_time} - {item?.formatted_coupon_detail_close_time}</Col>
                            {/* <Col>{item?.formatted_open_time} - {item?.formatted_close_time == '12:00 am (midnight next day)' ? '12:00 am *' : item?.formatted_close_time}</Col> */}
                        </Row>
                    )}
                    {/* {(midnighNote) ? <p className='mt-3'>*midnight next day</p> : ''} */}
                </Modal.Body>
                <Modal.Footer className='confirationModalfooter py-0'>
                    {(cancelButton) && <Button variant={`light ${cancleButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => setIsModalOpen()}>{cancelButtonLabel}</Button>}
                    {(SubmitButton) && <Button variant={`light ${SubmitButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => handleLogout()}>{SubmitButtonLable}</Button>}
                    {isHandleSubmit && <Button variant={`light ${SubmitButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => handleFormSubmit()}>{SubmitButtonLable}</Button>}
                </Modal.Footer>
            </Modal>
        </>
    )
}

ParkingSchModal.propTypes = {
    dispatch: PropTypes.func,
    isModalOpen: PropTypes.bool,
    setIsModalOpen: PropTypes.func,
    Message: PropTypes.string,
    data: PropTypes.array,
    midnighNote: PropTypes.bool,
    cancelButton: PropTypes.bool,
    cancelButtonLabel: PropTypes.string,
    SubmitButton: PropTypes.bool,
    SubmitButtonLable: PropTypes.string,
    SubmitButtonColor: PropTypes.string,
    handleLogout: PropTypes.func,
    handleSubmit: PropTypes.func,
    cancleButtonColor: PropTypes.string,
    isHandleSubmit: PropTypes.bool,
    setIsSubmittingForm: PropTypes.func,
}

ParkingSchModal.defaulProps = {
    dispatch: noop,
    isModalOpen: false,
    setIsModalOpen: noop,
    Message: '',
    data: EMPTY_ARRAY,
    midnighNote: false,
    cancelButton: false,
    cancelButtonLabel: '',
    SubmitButton: false,
    SubmitButtonLable: '',
    SubmitButtonColor: '',
    handleLogout: noop,
    handleSubmit: noop,
    cancleButtonColor: '',
    isHandleSubmit: false,
    setIsSubmittingForm: noop,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ParkingSchModal)